import React from "react";
import ReactECharts from 'echarts-for-react';

const SERVICE_COLORS = {
  TTT: "#1e6c56",  // Dark Green
  TTS: "#c99718",  // Gold / Yellow
  STT: "#00b074",  // Vibrant Green
  STS: "#ff8a3d",  // Orange
};

const ApiUsageLineChart = ({ activeSubTab = "overview", dailyServiceUsage = [] }) => {
  const daysList = (dailyServiceUsage && dailyServiceUsage.length > 0)
    ? dailyServiceUsage.map(d => d.day)
    : ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

  const getOption = () => {
    if (activeSubTab !== "overview") {
      const sKey = activeSubTab.toUpperCase();
      const color = SERVICE_COLORS[sKey] || SERVICE_COLORS.TTT;
      const data = dailyServiceUsage.map(d => d[sKey] || 0);

      return {
        tooltip: { trigger: "axis" },
        grid: { left: "3%", right: "4%", bottom: "5%", top: "8%", containLabel: true },
        xAxis: { type: "category", boundaryGap: false, data: daysList, axisLine: { lineStyle: { color: "#E5E7EB" } } },
        yAxis: { type: "value", splitLine: { lineStyle: { color: "#F3F4F6" } } },
        series: [
          {
            name: sKey,
            type: "line",
            smooth: 0.45,
            symbol: "none",
            lineStyle: { width: 3, color },
            areaStyle: {
              color: {
                type: "linear", x: 0, y: 0, x2: 0, y2: 1,
                colorStops: [
                  { offset: 0, color: `${color}40` },
                  { offset: 1, color: `${color}05` }
                ]
              }
            },
            data: data.length > 0 ? data : [120, 180, 210, 190, 220, 250, 310]
          }
        ]
      };
    }

    return {
      tooltip: { trigger: "axis" },
      grid: { left: "3%", right: "4%", bottom: "5%", top: "8%", containLabel: true },
      xAxis: { type: "category", boundaryGap: false, data: daysList, axisLine: { lineStyle: { color: "#E5E7EB" } } },
      yAxis: { type: "value", splitLine: { lineStyle: { color: "#F3F4F6" } } },
      series: [
        {
          name: "TTT", type: "line", smooth: 0.45, symbol: "none",
          lineStyle: { width: 2.5, color: SERVICE_COLORS.TTT },
          areaStyle: { color: { type: "linear", x: 0, y: 0, x2: 0, y2: 1, colorStops: [{ offset: 0, color: "rgba(30, 108, 86, 0.18)" }, { offset: 1, color: "rgba(30, 108, 86, 0.01)" }] } },
          data: dailyServiceUsage.map(d => d.TTT || 0)
        },
        {
          name: "TTS", type: "line", smooth: 0.45, symbol: "none",
          lineStyle: { width: 2.5, color: SERVICE_COLORS.TTS },
          areaStyle: { color: { type: "linear", x: 0, y: 0, x2: 0, y2: 1, colorStops: [{ offset: 0, color: "rgba(201, 151, 24, 0.18)" }, { offset: 1, color: "rgba(201, 151, 24, 0.01)" }] } },
          data: dailyServiceUsage.map(d => d.TTS || 0)
        },
        {
          name: "STT", type: "line", smooth: 0.45, symbol: "none",
          lineStyle: { width: 2.5, color: SERVICE_COLORS.STT },
          areaStyle: { color: { type: "linear", x: 0, y: 0, x2: 0, y2: 1, colorStops: [{ offset: 0, color: "rgba(0, 176, 116, 0.18)" }, { offset: 1, color: "rgba(0, 176, 116, 0.01)" }] } },
          data: dailyServiceUsage.map(d => d.STT || 0)
        },
        {
          name: "STS", type: "line", smooth: 0.45, symbol: "none",
          lineStyle: { width: 2.5, color: SERVICE_COLORS.STS },
          areaStyle: { color: { type: "linear", x: 0, y: 0, x2: 0, y2: 1, colorStops: [{ offset: 0, color: "rgba(255, 138, 61, 0.18)" }, { offset: 1, color: "rgba(255, 138, 61, 0.01)" }] } },
          data: dailyServiceUsage.map(d => d.STS || 0)
        }
      ]
    };
  };

  return (
    <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-6">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-4">
        <h3 className="text-xl font-bold text-gray-900">API Usage (Last 7 Days)</h3>
        {activeSubTab === "overview" && (
          <div className="flex items-center gap-4 text-xs font-semibold text-gray-600 flex-wrap">
            <div className="flex items-center gap-1.5"><span className="w-2.5 h-2.5 rounded-full bg-[#1e6c56]" /><span>TTT</span></div>
            <div className="flex items-center gap-1.5"><span className="w-2.5 h-2.5 rounded-full bg-[#c99718]" /><span>TTS</span></div>
            <div className="flex items-center gap-1.5"><span className="w-2.5 h-2.5 rounded-full bg-[#00b074]" /><span>STT</span></div>
            <div className="flex items-center gap-1.5"><span className="w-2.5 h-2.5 rounded-full bg-[#ff8a3d]" /><span>STS</span></div>
          </div>
        )}
      </div>

      <div className="h-72">
        <ReactECharts option={getOption()} style={{ height: "100%", width: "100%" }} />
      </div>
    </div>
  );
};

export default ApiUsageLineChart;
